import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import { ToggleWrapper } from './style';

const CustomToggle = ({ children, checked, disabled = false, onClick, id }) => {
  return (
    <ToggleWrapper onClick={onClick} className={disabled ? 'disabled' : ''}>
      {children}
      <Toggle
        id={id}
        checked={checked}
        onChange={() => { }}
        icons={false}
        disabled={disabled}
      />
    </ToggleWrapper>
  );
};

CustomToggle.propTypes = {
  children: PropTypes.node,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  id: PropTypes.string,
};

export default CustomToggle;
